import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const resourceList = createAsyncThunk('resource/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `amenity_resource`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'resource_status': data?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const resourceDetails = createAsyncThunk('resource/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `amenity_resource/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const resourceSlotAvailability = createAsyncThunk('resource/slots', async ({ id, date, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `resource_slot/${id}`,
            params: {
                'date': date
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delResource = createAsyncThunk('resource/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `amenity_resource/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addResource = createAsyncThunk('resource/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'amenity_resource',
            data: {
                "premise_id": data?.values?.premise_id,
                "resource_name": data?.values?.name,
                "resource_status": data?.values?.status,
                "opening_time": data?.values?.opening_time,
                "closing_time": data?.values?.closing_time,
                "slot_duration": data?.values?.slot_duration,
                "max_slots": data?.values?.max_slots,
                "capacity": data?.values?.capacity,
                "description": data?.values?.description,
                "is_public": data?.values?.is_public,
                "is_private": data?.values?.is_private,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateResource = createAsyncThunk('resource/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'amenity_resource',
            data: {
                "amenity_resource_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "resource_name": data?.values?.name,
                "resource_status": data?.values?.status,
                "opening_time": data?.values?.opening_time,
                "closing_time": data?.values?.closing_time,
                "slot_duration": data?.values?.slot_duration,
                "max_slots": data?.values?.max_slots,
                "capacity": data?.values?.capacity,
                "description": data?.values?.description,
                "is_public": data?.values?.is_public,
                "is_private": data?.values?.is_private,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const resource = createSlice({
    name: 'resource',
    initialState: {
        list: [],
        details: null,
        slots: [],
        booking_summary: null,
        slotsLoading: false,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(resourceList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })

        builder.addCase(resourceDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })

        builder.addCase(resourceSlotAvailability.pending, (state) => {
            state.slotsLoading = true
        })

        builder.addCase(resourceSlotAvailability.fulfilled, (state, action) => {
            state.slotsLoading = false

            if (action?.payload?.status === 200) {
                const data = action.payload.data?.data || {}
                state.slots = data.slots || []
                state.booking_summary = data.booking_summary || null
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
                state.slots = []
                state.booking_summary = null
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.slots = []
                state.booking_summary = null
            } else {
                state.slots = []
                state.booking_summary = null
            }
        })

        builder.addCase(resourceSlotAvailability.rejected, (state) => {
            state.slotsLoading = false
            state.slots = []
            state.booking_summary = null
        })
    }
})

export default resource.reducer;